import React from 'react'
import Auth from "../Services/Auth";
import { Redirect, Route } from 'react-router-dom'

/**
 * Guards a route on login, and optionally on a permission.
 *
 *   <PrivateRoute path="/roles" perm="subAdmins" component={RoleList} />
 *   <PrivateRoute path="/settings" perm={{ module: 'settings', action: 'write' }} component={Setting} />
 *
 * `perm` as a string checks read access to that module; as {module, action} it checks that
 * action. A logged-in user without the permission is bounced to the dashboard rather than the
 * login page. This is UI convenience only — the API enforces the same permission itself.
 */
const PrivateRoute = ({ component: Component, pageLoader: pageLoader, perm, ...rest }) => {
  const isLoggedIn = Auth.isLoggedIn()

  const allowed = () => {
    if (!perm) return true
    if (typeof perm === 'string') return Auth.can(perm, 'read')
    return Auth.can(perm.module, perm.action || 'read')
  }

  return (
    <Route
      {...rest}
      render={props =>
        !isLoggedIn ? (
          <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
        ) : allowed() ? (
          <Component {...props} pageLoader={pageLoader} />
        ) : (
          <Redirect to={{ pathname: '/dashboard' }} />
        )
      }
    />
  )
}

export default PrivateRoute
